import { QueueLayout } from "../../features/web3/forex/components/QueueLayout";
import { Td } from "../../features/web3/forex/components/table";
import { useQueryClient } from "@tanstack/react-query";
import { formatDateTime } from "../../lib/format";
import { ListView, Unavail, UserLink, mono, muted } from "./parts";

const COLUMNS = [
  { label: "Username" },
  { label: "Name" },
  { label: "Real accounts", align: "right" },
  { label: "Demo accounts", align: "right" },
  { label: "Live masters", align: "right" },
  { label: "Standing connections", align: "right" },
  { label: "First seen" },
];

const counts = (c) => `${c.regular} + ${c.copyTrading} copy`;

// Names come from the trading server's oldest account: null when there is none
// or the mirror is down.
const name = (r) =>
  r.firstName == null && r.lastName == null ? <Unavail /> : `${r.firstName ?? ""} ${r.lastName ?? ""}`.trim() || "—";

const row = (r) => (
  <tr key={r.username} className="hover:bg-white/[0.02]">
    <Td className={mono}><UserLink username={r.username} /></Td>
    <Td className="whitespace-nowrap">{name(r)}</Td>
    <Td align="right" className={mono}>{counts(r.accountCounts.real)}</Td>
    <Td align="right" className={mono}>{counts(r.accountCounts.demo)}</Td>
    <Td align="right" className={mono}>{r.liveMasters}</Td>
    <Td align="right" className={mono}>{r.standingConnections}</Td>
    <Td className={muted}>{formatDateTime(r.firstSeenAt)}</Td>
  </tr>
);

export default function Users() {
  const qc = useQueryClient();
  return (
    <QueueLayout
      eyebrow="Forex Admin"
      title="Forex"
      accent="users"
      description="Anyone on a trading account, a connection, a transfer or a charge. Newest first seen first."
      onRefresh={() => qc.invalidateQueries({ queryKey: ["forex-admin"] })}
    >
      <ListView path="/users/admin" empty={{ username: "" }}
        fields={[{ name: "username", label: "Username (exact)" }]}
        columns={COLUMNS} row={row} label="users" />
    </QueueLayout>
  );
}
